import { FlowVersionStatus } from "src/clients/flow-api";
import { useCapabilities } from "src/hooks/useCapabilities";
import { useHasSimulation } from "src/hooks/useHasSimulation";
import { useAuthoringContext } from "src/router/routerContextHooks";

/**
 * @returns whether the current version can be edited by checking permissions and version status.
 */
export const useCanAuthoringEditFlowVersion = () => {
  const { flowVersions } = useCapabilities();
  const { version, isRevision } = useAuthoringContext();
  const hasSimulation = useHasSimulation();
  return (
    flowVersions.canEdit &&
    version.status !== FlowVersionStatus.PUBLISHED &&
    version.status !== FlowVersionStatus.ARCHIVED &&
    !hasSimulation &&
    !isRevision
  );
};
